import React, {Component} from 'react';
import {NavBar, List, InputItem,Checkbox, Toast} from 'antd-mobile';
import {getStation,assistOrder,getPrice,getStartPoint,startStation} from "../../../service/preOrderService";
import {connect} from "react-redux";
import {addPassenger} from "../../../service/passengerService";
import storage from '../../../utils/localStore';
import './style.less';
const CheckboxItem = Checkbox.CheckboxItem;
//出发地点
var porpStartAddressPoint = '';//全局数据，用于保存地址选择后的数据，经纬度
var porpStartAddress = '';//全局数据，用于保存地址选择后的数据，
//目的地
var porpEndAddressPoint = '';//全局数据，用于保存地址选择后的数据，经纬度
var porpEndAddress = '';//全局数据，用于保存地址选择后的数据，
var endCityName,endStationId;//到达起止点名字，到达起止点的id
var lastSeatId = '';//上一次选中的出行位置id
var integral = storage.getItem('integral', integral);//个人中心的个人积分
let riderDataName,riderDataIdcard,riderDataPhone,idType,startStationId,placevalue;
let argName =''
@connect(
    state => ({userInfo: state.userInfo}),
)

export default class AddPassengers extends Component {
    constructor(props) {
        super(props);  
        console.log(props) 
        this.state = {
            data: [],
            name: riderDataName ? riderDataName : '',
            phone:riderDataPhone ? riderDataPhone: '',
            IdCard: riderDataIdcard ? riderDataIdcard : '',
            seatNo: 0,//出行位置号
            seatPrice: 0,//出行位置价格
            pickUpPrice:0,//接分流价格
            deliveryPrice:0,
            preferentialPrice:0,//优惠价格
            integral:0,//抵扣积分
            countChecked:1,
            childChecked:0,
            addChecked:riderDataName ? 0 : 1,
            priceShow:false,
            startAddress: porpStartAddress == '' ? (this.props.history.location.state ? this.props.history.location.state.startAddress : '') : porpStartAddress,
            endAddress: porpEndAddress == '' ? (this.props.history.location.state ? this.props.history.location.state.endAddress : '') : porpEndAddress,
            passport:[
                    {
                        "value":0,
                        "desription":"身份证"
                    },
                    {
                        "value":1,
                        "desription":"护照"
                    },
                    {
                        "value":2,
                        "desription":"边民证"
                    }
            ],
           placevalue:placevalue ? placevalue : 0,//0是身份证，1是护照,2是边民证
           startPoint:'',//出发起止点经纬度
           endStation:[],//到达起止点数组
           startPointName:'',//出发起止点具体位置
           startArray:[],//出发起止点的数组
        };

        this._returnAddressResult = this._returnAddressResult.bind(this);
        this._toChooseAddress = this._toChooseAddress.bind(this);
        this.returnRiderData = this.returnRiderData.bind(this);
        this.goRider = this.goRider.bind(this);
    }

   componentWillMount(){
       var propState = this.props.location.state
       var seatId = propState ? propState.seatId : '';
    //    var lineIdT = propState ? propState.seatId : '';
       if(lastSeatId == ''){
        lastSeatId = seatId;
       }else if(lastSeatId != seatId){//传入新的seatId时，初始化出发点和终点的地点信息
            lastSeatId = seatId;
            porpStartAddress = '';
            porpStartAddressPoint = '';
            porpEndAddress = '';
            porpEndAddressPoint = '';
            riderDataName = '';
            placevalue= '';
            riderDataIdcard = '';
            riderDataPhone = '';
            this.setState({
                startAddress:'',
                endAddress:'',
            })
       } 
   
   }

    componentDidMount() {
        this.getStart();//出发城市列表
        // this.getStartPoint();
        if(this.state.startAddress){
            this.getReach();
        }
        if(this.state.startAddress && this.state.endAddress){
            setTimeout(() => {
                this.getPrice();
            }, 1000);
        }
    }
    //常用乘车人页面返回数据
    returnRiderData(datas){
        riderDataName = datas.name;
        riderDataIdcard = datas.idNum;
        riderDataPhone = datas.phone;
        placevalue = datas.idType;
        idType = datas.idType;
     
    }

    /**
     * 地址选择页面返回数据
     * @param {object} datas 
     */
    _returnAddressResult(datas){
        startStationId = datas.startStationId
        let address = datas.address;
        switch (datas.type) {
            case 'start':
                if(datas.point.length > 0){
                    let startBackPoint = datas.point
                    
                    porpStartAddressPoint = startBackPoint[1] + '_' +startBackPoint[0] ;
                }else{
                    let startBackPoint = datas.point;
                    porpStartAddressPoint = startBackPoint.lat + '_' + startBackPoint.lng;
                }
                porpStartAddress = address;
                break;
            case 'end':
                if(datas.point.length){
                    let endBackPoint = datas.point;
                    porpEndAddressPoint = endBackPoint[1] + '_' + endBackPoint[0];
                }else{
                    let endBackPoint = datas.point;
                    porpEndAddressPoint = endBackPoint.lat + '_' + endBackPoint.lng;
                }
                porpEndAddress = address;
                endCityName = datas.endCity;
                endStationId = datas.endStationId;
                break;
        }
    }
    //跳转常用乘车人页面
    goRider(type){
        let datas = {type:type,data:this.props.location.state,returnData:this.returnRiderData.bind(this)}
        this.props.history.push({pathname:'/FrequentlyPassenger',datas:datas})
    }
    /**
     * 跳转到地址选择页面
     * 
     * @param {string} type 
     */
    _toChooseAddress(type){
        var datas = {type:type,returnData:this._returnAddressResult.bind(this)};
        var historyData = {
            pathname:'/SelAddress',
        };
        if(type == 'start'){
            datas.address = this.state.startAddress;
            historyData.startCity=this.props.location.state.startCity;
            historyData.startPoint=this.state.startPoint;
            historyData.startPointName=this.state.startPointName;
            historyData.startStationId=startStationId;
            historyData.startArray=this.state.startArray;
        }else if(type == 'end'){
            if (!this.state.startAddress) {
                Toast.info('请选择上车地址');
                return
            } 
            datas.address = this.state.endAddress;
            historyData.endStation=this.state.endStation;
            historyData.endCity=this.props.location.state.endCity;
            historyData.endStationId=this.props.location.state.endStationId;
        }
        historyData.datas=datas;
        this.props.history.push(historyData)
       
    }
    //出发城市数组
    getStart = () =>{
        let params = {
            token: this.props.userInfo.token,
            "data":{
                "id":this.props.location.state.lineId,
            }
        };
        startStation(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    this.setState({
                        startArray:res.data.data
                    })
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
        });
    }
    //根据出发起止点id获取出发起止点的地名和经纬度
    getStartPoint = () => {
        let params = {
            token: this.props.userInfo.token,
            "data":{
                "startStationId":startStationId,//上车地址城市的起止点Id
                "lineId":this.props.location.state.lineId,
            }
        };
        getStartPoint(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    this.setState({
                        startPoint:res.data.data.location,
                        startPointName:res.data.data.address
                    })
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
        });
    };
    //根据起止区域id获取到达起止点以及到达起止点id
    getReach = () => {
        let params = {
            token: this.props.userInfo.token,
            "data":{
                "lineId":this.props.location.state.lineId,
                "startStationId":startStationId,
            }
        };
        getStation(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setState({
                        endStation:res.data.data
                    })
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
        });
    };
   //代下单计算接口
    getPrice = () => {
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "shiftId": this.props.location.state.classId,
                "startPosition":porpStartAddressPoint,
                "endPosition": porpEndAddressPoint,
                "seatId": this.props.location.state.seatId,
                "startStationId":startStationId,
                "endStationId":endStationId,
                "lineId": this.props.location.state.lineId,//起止区域id
            }
           
        };
        Toast.loading("正在加载",0);
        getPrice(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    Toast.hide();
                    let data = res.data.data
                    this.setState({
                        priceShow:true,
                        deliveryPrice:data.sendPrice ? data.sendPrice : 0,
                        pickUpPrice:data.pickUpPrice ? data.pickUpPrice : 0,
                        seatPrice:data.seatPrice,
                        seatNo:data.seatNum,
                        preferentialPrice:data.preferentialPrice ? data.preferentialPrice : 0
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
        });
    };
   //下单
    addPassenger = () => {
        const nullReg = /^\s*$/;
        const telReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
        const IdCardReg = /^[1-9]\d{5}[1|2]\d{3}(([0]\d)|([1][0|1|2]))(([0|1|2]\d)|((30)|(31)))\d{3}[(0-9)|x|X]$/;
       if (this.state.startAddress.length === 0) {
            Toast.info('请选择上车地址');
        } else if (this.state.endAddress.length === 0) {
            Toast.info('请选择下车地址');
        }else if(this.state.IdCard.length < 5 ){
            Toast.info('证件位数不能少于5位');
        }
         else {
            let params = {
                "token": this.props.userInfo.token,
                "data": {
                    "source": "6",
                    "startAddress": this.state.startAddress,//出发地址
                    "endAddress": this.state.endAddress,//到达地址
                    "shiftId": this.props.location.state.classId,//行程id
                    "lineId": this.props.location.state.lineId,//起止区域id
                    "startPosition": porpStartAddressPoint,//出发地址经纬度
                    "endPosition": porpEndAddressPoint,//到达地址经纬度
                    "seatId": this.props.location.state.seatId,//出行位置id
                    "startStationId":startStationId,//出发起止点id
                    "endStationId": endStationId,//到达起止点id
                    "phone":this.state.phone.replace(/\s/ig, ''),//手机号
                    "startCity": this.props.location.state.startCity,//出发起止点
                    "endCity": endCityName,//到达起止点
                    "seatPrice":this.state.seatPrice,//出行位置价格
                    "pickUpPrice": this.state.pickUpPrice,//接分流价格
                    "deliveryPrice": this.state.deliveryPrice,//送分流价格
                    "integral":this.state.countChecked == 1 ? this.state.integral : 0,//抵扣积分
                    "passengerName":this.state.name,
                    "idType":this.state.placevalue == 0 ? "idcard":(this.state.placevalue == 1 ? "passport":"borderCard"),//证件类型
                    "idNum":this.state.IdCard,//证件号码
                    "isChild":Number(this.state.childChecked),//是否是儿童
                    "commonPassenger":Number(this.state.addChecked)//是否添加到常用乘车人 1是添加
                }
            };
            Toast.loading("正在加载",0);
                assistOrder(params)
                    .then((res) => {
                        if (res.data.code === '0000') {
                            Toast.hide();
                            //跳转支付页面
                            let totalPrice = this.state.seatPrice + this.state.pickUpPrice + this.state.deliveryPrice - this.state.integral
                            this.props.history.push('/payDetail',{
                                orderNum:res.data.data,
                                seatNum:this.state.seatNo,
                                totalPrice:totalPrice.toFixed(2),
                                type:0,//0是正常支付，1是改签，2是发票
                            })//把订单id,出行位置号，总价传到支付页面
                        } else if (res.data.code === '1401') {
                            document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                        }
                        else {
                            Toast.info(res.data.msg);
                        }
                    }).catch(function (error) {
                });
        }
    };
    show_sub(e){     
        var newVal = e.target.value
        this.setState({
            placevalue:newVal
        })
    }    
    onChange=(e,key)=>{
        this.setState({
            [key]:e.target.checked
        })
    }
    infoChange=(e,key)=>{
        this.setState({
            [key]:e
        })
    }
    scan = () =>{
        document.location = `js://scan?orderNum=${this.props.history.location.state.orderNum}`;
    }
    dataFromAndroid(arg){
        alert(arg) 
        argName = arg
             
    }
    render() {
        let totalPrice = this.state.seatPrice + this.state.pickUpPrice + this.state.deliveryPrice - this.state.integral;
        return (
            <div className="addPassengers">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >添加乘客</NavBar>
                <List className="address">
                    <List.Item
                        thumb={<div className="addressIcon start"/>}
                        onClick={this._toChooseAddress.bind(this,'start')}
                    >{this.state.startAddress ? this.state.startAddress :  <span>在哪儿上车？</span>}</List.Item>
                    <List.Item
                        thumb={<div className="addressIcon end"/>}
                        onClick={this._toChooseAddress.bind(this,'end')}
                    >{this.state.endAddress ? this.state.endAddress : <span>去哪儿？</span>}</List.Item>
                </List>
                <div className="selectRider"  onClick={this.goRider.bind(this,'0')}><i className="icon iconfont iconxuanzechangyongchengcheren"></i>选择常用乘车人</div>
                <div className="checkbox">
               {/*  <CheckboxItem onChange={(e) => this.onChange(e,'childChecked')} checked={this.state.childChecked}><span>儿童</span></CheckboxItem> */}
                <CheckboxItem onChange={(e) => this.onChange(e,'addChecked')} checked={this.state.addChecked}><span>添加到常用乘车人</span></CheckboxItem>
                </div>
                <List className="passengerInfo">
                    
                    <div className="inputBpx">
                        <i className="icon iconfont iconxingming"></i>
                        <InputItem 
                            placeholder="填写姓名" 
                            value={this.state.name}
                            onChange={(val) => this.infoChange(val, 'name')}
                        ></InputItem>
                        {/* <i className="icon iconfont iconsaomiao" onClick={()=>this.scan()}></i> */}
                    </div>
                    <div className="inputBpx">
                        <i className="icon iconfont iconshouji"></i>
                        <InputItem 
                            type="phone" 
                            placeholder="填写联系手机号" 
                            value={this.state.phone}
                            onChange={(val) => this.infoChange(val, 'phone')}
                        ></InputItem>
                    </div>
                    <div className="inputBpx">
                        <i className="icon iconfont iconshenfenzheng"></i>
                        
                       
                        <select onChange={(v)=>this. show_sub(v)}>
                            {this.state.passport.map((res,i)=>(
                                <option key={i} selected={res.value == (idType =='passport'? 1:(idType =='borderCard'? 2:0))} value={res.value}>{res.desription}</option>
                            ))}
                        
                        </select>
                    
                        <InputItem 
                            maxLength={18} 
                            placeholder={this.state.placevalue == 0 ? "请填写身份证号":(this.state.placevalue == 1 ? "请填写护照号":"请填写边民证号")}
                            value={this.state.IdCard} 
                            className="card"
                            onChange={(val) => this.infoChange(val, 'IdCard')}
                        ></InputItem>
                    </div>
                </List>
               
                {
                    this.state.integral == 0 ?  <div className="noIntegral">本次订单暂无可使用积分</div> :
                    <div className="count">
                        <i className="icon iconfont iconjifen"></i>
                        <div>本次订单可使用<span>{this.state.integral}积分</span>抵扣<span>{this.state.integral}元</span></div>
                        <CheckboxItem onChange={(e) => this.onChange(e,'countChecked')} checked={this.state.countChecked}></CheckboxItem>
                    </div>
                }
                {
                    this.state.priceShow ?
                        <div>  
                            <div className="priceInfo">
                                <div className="title">费用明细</div>
                                <div className="content">
                                    <div>
                                        <span>出行位置</span>
                                        <span>{this.state.seatNo}</span>
                                    </div>
                                    <div>
                                        <span>出行位置价格</span>
                                        <span>¥{this.state.seatPrice}</span>
                                    </div>
                                    <div>
                                        <span>出发地溢价</span>
                                        <span>¥{this.state.pickUpPrice}</span>
                                    </div>
                                    <div>
                                        <span>到达地溢价</span>
                                        <span>¥{this.state.deliveryPrice}</span>
                                    </div>
                                    <div>
                                        <span>活动折扣</span>
                                        <span>¥{this.state.integral}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="footerPay">
                                <div>总计：<span>¥{totalPrice.toFixed(2)}</span></div>
                                <button className="sureBtn" onClick={this.addPassenger}>立即支付</button>
                            </div>
                        </div>
                :null
                }
                    
              
               
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Shift/AddPassengers/index.js